export function createMilestonesApi(http) {
  return {
    create: (goalId, body) => http.post(`/api/goals/${goalId}/milestones`, body),
    patch: (id, body) => http.patch(`/api/milestones/${id}`, body),
    remove: (id) => http.del(`/api/milestones/${id}`),
    reorder: (goalId, order) => http.patch(`/api/goals/${goalId}/milestones/reorder`, { order }),
  }
}
